import React from 'react';
import { ProFormSelect } from '@ant-design/pro-form';
import { useQuery, gql } from '@apollo/client';
import { formatEnum } from '../../../utils';
import { PLACEHOLDER } from 'constants/form';

const GET_REPORT_TYPES = gql`
  query GET_REPORT_TYPES {
    reportTypes: __type(name: "ReportType") {
      enumValues {
        name
      }
    }
  }
`;

const SelectReportType = ({ ...props }) => {
  const { data, loading } = useQuery(GET_REPORT_TYPES);
  const options = loading
    ? []
    : data.reportTypes.enumValues.map(({ name }) => ({
        value: name,
        label: formatEnum(name),
      }));
  return (
    <ProFormSelect
      fieldProps={{ loading }}
      width="xl"
      name="reportType"
      label="Report Type"
      placeholder={PLACEHOLDER.PLEASE_SELECT}
      options={options}
      {...props}
    />
  );
};

export default SelectReportType;
